import Vue from 'vue'
import axios from 'axios'
// import store from '@/store'
import notification from 'ant-design-vue/es/notification'
import {
  Modal
} from 'ant-design-vue'
import {
  VueAxios
} from './axios'
import {
  ACCESS_TOKEN
} from '@/store/mutation-types'

const qs = require('querystring')

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
  timeout: 6000, // 请求超时时间
})

const err = error => {
  if (error.response) {
    const data = error.response.data
    // const token = Vue.ls.get(ACCESS_TOKEN)
    // 登录token验证的接口必须在请求头带token，导致即使请求验证失败，token依然会存在缓存中
    // 所以这里判断在登录页面，请求失败，清空token
    // if (token === 'ZGV2OmRldg==' && location.pathname === '/user/login') {
    //   Vue.ls.remove(ACCESS_TOKEN)
    // }
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    }
    const search = qs.decode(location.search)
    if (!search.ignoreLogin) {
      if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
        notification.error({
          message: 'Unauthorized',
          description: 'Authorization verification failed'
        })
      }
    }

    if (error.response.status.toString().startsWith('50')) {
      Modal.error({
        title: '错误!',
        content: data.msg || data.message || error.response.message || '也不说为啥开小差'
      })
    }
    // if (error.response.status === 404) {
    //   Modal.error({
    //     title: '服务器没这个功能!',
    //     content: `${error.response.config.method}: ${data.path}`
    //   })
    // }
    if (error.response.status === 400) {
      Modal.error({
        title: '错误!',
        content: error.response.data.msg
      })
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  // const Authorization = token === 'ZGV2OmRldg==' ? 'Basic' : 'Bearer'
  const isOss = config.url === 'https://gateway.51lss.com/oss/oss/sts' // 判断是否是oss鉴权地址，因未知原因设计乐等实训平台鉴权不能带token
  if (token && !Vue.ls.get('isObsRequest') && !isOss) {
    // config.headers['Authorization'] = `${Authorization} ${token}`
    config.headers['Content-Type'] = 'application/json'
  }
  // 为满足后端 java 的的请求参数要求设置的
  if (config.url === '/oauth/token') {
    if (config.method === 'post') {
      config.data = qs.stringify(config.data)
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
  }
  return config
}, err)
// response interceptor
service.interceptors.response.use(response => {
  Vue.ls.remove('isObsRequest')
  switch (response.data.statusCode) {
    case '0':
      Modal.error({
        title: '错误!',
        content: response.data.msg || '也不说为啥开小差'
      })
      return
    case '300':
      Modal.error({
        title: '错误!',
        content: response.data.msg || '也不说为啥开小差'
      })
      return
    case '501':
      Modal.error({
        title: '错误!',
        content: response.data.msg || '也不说为啥开小差'
      })
      return
  }
  // if (response.data.data) {
  //   return response.data.data
  // }
  return response.data
}, err)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios, service as axios
}
